'use client';

import React, { FC } from 'react';
import TextareaAutosize, { TextareaAutosizeProps } from 'react-textarea-autosize';

import styles from './styles.module.css';

type Props = TextareaAutosizeProps;

const Textarea: FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <TextareaAutosize className={styles.input} {...props} />
    </div>
  );
};

export default Textarea;
